import {
	createContext,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react';
import storageManager from '@/api/storageManager';
import { updateCustomerLanguage } from '@/api/query/customer';
import { LANG_OPTIONS } from '@/common/constants/languages';
import { isAuthenticated } from '@/common/contexts/GuestAuthContext';
import { applyLanguage, readInitialLanguage } from '@/common/utils/language';

export { LANG_OPTIONS } from '@/common/constants/languages';

export const LanguageContext = createContext(null);

const LanguageContextProvider = ({ children }) => {
	const [lang, setLang] = useState(
		() => readInitialLanguage() ?? LANG_OPTIONS.english,
	);

	useEffect(() => {
		document.documentElement.lang = lang;
	}, [lang]);

	const switchLanguage = useCallback(async (nextLang) => {
		const token = storageManager.auth.getToken();
		const refreshToken = storageManager.auth.getRefreshToken();

		if (isAuthenticated()) {
			try {
				await updateCustomerLanguage({ language: nextLang });
			} catch {}
		}

		applyLanguage(nextLang, setLang, {
			transferAuth: Boolean(token),
			token,
			refreshToken,
		});
	}, []);

	const value = useMemo(
		() => ({
			lang,
			switchLanguage,
		}),
		[lang, switchLanguage],
	);

	return (
		<LanguageContext.Provider value={value}>
			{children}
		</LanguageContext.Provider>
	);
};

export default LanguageContextProvider;
